import request from "@/utils/request";

export function getGoodsRecord(params) {
  return request({
    url: "/product/access-log/goods-record",
    method: "get",
    params,
  });
}
